<template>
  <Dialog
    v-bind="$attrs"
    title="Decline"
    subTitle="Please provide comments to assist the author to understand why you declined the endorsement."
    :width="$vuetify.breakpoint.mdAndUp ? 800 : $vuetify.breakpoint.smAndUp ? 600 : 360"
    v-on="$listeners"
  >
    <template #content>
      <div class="share-card__wrapper mt-6">
        <v-card-text>
          <AdsSelect
            v-show="false"
            v-model="assignee"
            label="Assignee"
            :items="approvers"
            item-text="name"
            item-value="userId"
            return-object
          />
          <AdsTextArea
            v-model="comments"
            label="Comments"
          />
        </v-card-text>
        <v-card-actions class="pa-4 pt-0">
          <v-spacer />
          <AdsButton
            buttonText="Cancel"
            tertiary
            @click="$downwardBroadcast('close:dialog')"
          />
          <AdsButton
            :loading="$store.state.isLoading"
            color="warning"
            button-text="Decline"
            @click="handleDecline"
          />
        </v-card-actions>
      </div>
    </template>
  </Dialog>
</template>

<script>
import {AdsButton, AdsSelect, AdsTextArea} from '@nswdoe/doe-ui-core';
import Dialog from '@/components/Dialogs/Dialog.vue';
import {mapGetters, mapState} from 'vuex';
import {EDPUSH_ACTION, ELASTIC_STATUS} from '@/constants';

export default {
  name: 'DeclineDialog',
  components: {
    AdsButton,
    Dialog,
    AdsSelect,
    AdsTextArea
  },
  props:{
    hubCollection: {
      type: Boolean,
      default: false
    },
    source: {
      type: String,
      default: null
    },
    recordId: {
      type: String,
      default: null
    },
    application: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      assignee: '',
      comments: '',
      reviewSubmitted: false,
    };
  },
  methods: {
    async handleDecline() {
      // 1. if edit mode, update the resource first
      if (this.editMode) {
        // await this.$parent.handleUpdate();
        await this.postEdPushAndElastic();
      } else {
        // preview mode
        await this.postEdPushAndElastic();
      }
    },
    async postEdPushAndElastic() {
      const {application, source, recordId} = this;

      // 2. EdPush Post
      const edPushResult = await this.$store.dispatch('editor/declineEndorsePendingResource', {
        assignee: this.assignee.name,
        assigneeId: this.assignee.userId,
        comments: this.comments,
        action: EDPUSH_ACTION.DECLINE,
        application,
        source,
        resourceId: recordId,
        name: this.title
      });
      console.log(edPushResult)
      if (edPushResult) {
        // close dialog
        this.$downwardBroadcast('close:dialog');
        // 3. Post Elastic for status Update in Elastic
        const elasticResult = await this.$store.dispatch(
          'editor/updateResourceStatus',
          {
            action: ELASTIC_STATUS.DECLINED,
            assigneeId: this.assignee.userId,
            application,
            source,
            recordId
          }
        );
        console.log(elasticResult);
        if (elasticResult) {
          this.$store.commit('editor/SET_DECLINE_SUBMITTED', true);
          if (this.hubCollection) {
            this.$emit('onSubmit', elasticResult);
          } else {
            await this.$router.push({name: 'ResourceEditorPage'});
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      approvers: 'editor/approvers'
    }),
    ...mapState({
      editMode: state => state.editor.editMode
    })
  }
};
</script>

<style lang="scss" scoped>
@import "src/scss/variables";

.share-card__wrapper {
  display: block;
  min-width: 240px;

  .v-divider {
    margin-bottom: 16px;
  }

  @media only screen and (max-width: 43.75em) {
    // 700px === 43.75em
    & {
      width: 100%;
      margin-top: 8px;
      display: flex;
      flex-direction: column;
    }
  }

  & .v-card__text span {
    display: block;

    &:last-child {
      margin-bottom: 12px;
    }
  }

  .v-btn {
    min-height: 2.5rem;
    padding-left: 12px;
    padding-right: 12px;
    font-weight: normal;
    display: flex;
    justify-content: space-between;
    border-color: $ads-light-40;
    background-color: $ads-white;
    color: $ads-white;

    &:focus {
      border: 2px solid $ads-navy;
      outline: none !important;
    }
  }

  button.v-btn > .v-btn__content {
    justify-content: center;
  }

  .btnText {
    color: white;
  }

  .v-divider {
    border-color: $ads-light-40;
  }
}
</style>
